import { Button, ButtonProps, CircularProgress, Tooltip } from "@mui/material";
import * as React from "react";
import SyncIcon from "@mui/icons-material/Sync";
import { useLanguage } from "../../Language";
import { useWindowVariables } from "../../WindowVariables";
import { axios } from "../../AxiosInstanceManager";
import { SuccessMessageControl } from "@tlc/ls2pac/app/controls/successMessageControl";
import { SimpleErrorDialog } from "@tlc/ls2pac/app/controls/simpleErrorDialog";
import * as dayjs from "dayjs";
import { Patron } from "@tlc/ls2pac/dto/Patron";
import { BorrowerChild } from "@tlc/ls2pac/dto/BorrowerChild";

interface HistoryUpdateHistoryRequest {
  patronId: string;
}

interface EResourceHistoryResponse {
  success: boolean;
  thereAreChanges: boolean;
  lastUpdated: string; // Date
  messageToken: string;
}

interface UpdateDigitalLoansButtonProps extends ButtonProps {
  patronId: Patron["patronId"] | BorrowerChild["barcode"];
  lastUpdated?: number;
  onUpdate?: () => void;
}

export const UpdateDigitalLoansButton: React.FC<
  UpdateDigitalLoansButtonProps
> = ({ patronId, lastUpdated, onUpdate, disabled, ...props }) => {
  const { translate, translateToken } = useLanguage();
  const { hasAuthorizedEResources } = useWindowVariables();

  const [loading, setLoading] = React.useState<boolean>(false);
  const [timestamp, setTimestamp] = React.useState<string>(
    lastUpdated ? dayjs(lastUpdated).format("L LTS") : translate("unknown")
  );

  if (hasAuthorizedEResources) {
    return (
      <>
        <Tooltip
          title={`${translate("digitalInformationLastUpdated")}: ${timestamp}`}
        >
          <Button
            {...props}
            disabled={disabled || loading}
            // loading={loading} TODO update to use loading prop in R2 and ditch icon shift
            onClick={async () => {
              setLoading(true);
              const payload: HistoryUpdateHistoryRequest = {
                patronId: patronId,
              };
              const { data } = await axios.post<EResourceHistoryResponse>(
                `pacApi/updateHistory`,
                payload
              );
              setLoading(false);
              if (data.success) {
                const { lastUpdated } = data;
                SuccessMessageControl.show(
                  translate("digitalLoanUpdateSuccessMessage")
                );
                setTimestamp(dayjs(lastUpdated).format("L LTS"));
                if (onUpdate) {
                  onUpdate();
                }
              } else {
                const { messageToken } = data;
                const message = messageToken
                  ? translateToken(messageToken)
                  : translate("digitalLoanUpdateFailureMessage");
                SimpleErrorDialog.show(message);
              }
            }}
            startIcon={
              loading ? (
                <CircularProgress color="inherit" size={20} />
              ) : (
                <SyncIcon />
              )
            }
          >
            {translate("updateDigitalInfo")}
          </Button>
        </Tooltip>
      </>
    );
  }

  return <></>;
};
